/**
 * Created by Victor Rojo on 14/10/19.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';

import {PetrolStatistics} from "./PetrolStatistics";

@Injectable()
export class PetrolStatisticsService{

  private basePath = "/ipetrol/api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  get(startDate:number, endDate:number): Promise<any>{
    let url = this.basePath + "statistics";
    let params = new HttpParams();
    params = params.append('startDate', startDate.toString())
      .append('endDate', endDate.toString());
    return this.http.get(url, { params: params })
      .toPromise()
      .then( res => res as PetrolStatistics[] )
      .catch( error => this.errorHandler(error) );
  }

}
